'use client'

import * as React from 'react'
import { cn } from '../../utils/cn'

export interface CardProps {
  children: React.ReactNode
  className?: string
  hover?: boolean
  href?: string
}

export function Card({
  children,
  className,
  hover = true,
  href
}: CardProps) {
  const cardClasses = cn(
    'landing-card',
    !hover && 'hover:border-[var(--landing-border)] hover:bg-[var(--landing-bg-card)]',
    className
  )

  if (href) {
    return (
      <a href={href} className={cn(cardClasses, 'block')}>
        {children}
      </a>
    )
  }

  return (
    <div className={cardClasses}>
      {children}
    </div>
  )
}
